import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'recovery-time-info',
  templateUrl: './recovery-time-info.component.html',
  styleUrls: ['./recovery-time-info.component.scss'],
  // Presentational leaf: every binding comes from @Input, so OnPush is safe and
  // skips re-checking this template on unrelated change detection passes.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RecoveryTimeInfoComponent implements OnInit {
  @Input() realTime: boolean = null
  @Input() snapshotTime: string = null

  constructor() {}

  ngOnInit(): void {}
}
